module.exports = __webpack_public_path__ + "static/img/chengzi.1737862c.png";